<template>
  <div class="radarChartWrapper">
    <div v-if="themes.length > 2" class="radarChart" :id="chartId">
      <span
        class="graph-themes-name"
        v-for="(theme, index) in themes"
        :key="theme.abbreviation"
        v-tooltip="theme.title"
        @click="theme.tooltip = !theme.tooltip"
        :style="{
          top: graphBubblesPositions[index].y + 'px',
          left: graphBubblesPositions[index].x + 'px'
        }"
      >
        <span>
          {{ theme.abbreviation }}
        </span>
      </span>
    </div>
  </div>
</template>


<script>
export default {
  name: "SpiderGraph",
  components: {
  },
  props: {
    themes: Array
  },
  created: function() {
    this.chartId = "radarChart_" + this._uid;
    for (let i = 0; i < this.themes.length; i++) {
      this.graphData[0].push({
        axis: "",
        value: this.themes[i].globalRating.rating,
        tooltip: ""
      });
    }
    this.graphBubblesPositions = this.setGraphThemesNamesPositions();
  },
  mounted: function() {
    // eslint-disable-next-line
    RadarChart("#"+this.chartId, this.graphData, this.radarChartOptions);
  },
  data: function() {
    return {
      graphBubblesPositions: [],
      graphData: [[]],
      radarChartOptions: {
        w: 160,
        h: 160,
        margin: { top: 40, right: 50, bottom: 40, left: 50 },
        maxValue: 100,
        levels: 4,
        labelFactor: 1.3,
        wrapWidth: 120,
        roundStrokes: false,
        fontSize: "14px",
        fontFamily: "Arial, Helvetica Neue', Helvetica, sans-serif",
        radialColor: "#CDCDCD",
        strokeColor: "#000000",
        // eslint-disable-next-line
        getBgColor: function(i) {
          return "#ffffff";
          /*
            if (i == 3) {
              return "#a10808";
            } else if (i == 2) {
              return "#d67c29";
            } else if (i == 1) {
              return "#2d5972";
            } else {
              return "#009900";
            }
            */
        }
      }
    };
  },
  methods: {
    setGraphThemesNamesPositions() {
      var nbBulles = this.themes.length;
      var width = this.radarChartOptions.w,
        height = this.radarChartOptions.h;
      var rayon =
        Math.min(width / 2, height / 2) * this.radarChartOptions.labelFactor;
      var xO = width / 2,
        yO = height / 2;
      var bulles = [];
      var angleDebut = Math.PI / 2;
      var pasAngle = (2 * Math.PI) / nbBulles;
      var angle = angleDebut;
      for (var i = 0; i < nbBulles; i++) {
        bulles.push({
          x:
            Math.round(Math.cos(angle) * rayon) +
            xO +
            this.radarChartOptions.margin.left,
          y:
            -Math.round(Math.sin(angle) * rayon) +
            yO +
            this.radarChartOptions.margin.top
        });
        angle -= pasAngle;
      }
      return bulles;
    }
  }
};
</script>


<style lang="sass" scoped>
@import "../../sass/_media.sass"
  
.radarChartWrapper

.radarChart
  position: relative
  width: 260px
  margin: 0 auto

.graph-themes-name
  position: absolute
  text-align: center
  width: 10em
  margin: -0.5em 0 0 -5em
  > span
    margin: 0 auto
    background: rgb(255,255,255,0.6)
    line-height: 1em
    cursor: help

</style>


